import React from 'react';
import { Edit2, Save } from 'lucide-react';
import { Tooltip } from '../../admin/components/shared/Tooltip.tsx';

interface InlineEditActionsProps {
  isEditing: boolean;
  isSaving?: boolean;
  onEdit?: () => void;
  onCancel?: () => void;
  editLabel?: string;
  cancelLabel?: string;
  saveLabel?: string;
  /** When true, Edit is disabled and does not call onEdit. */
  editDisabled?: boolean;
  /** Shown on hover when Edit is disabled. */
  editDisabledReason?: string;
}

export const InlineEditActions: React.FC<InlineEditActionsProps> = ({
  isEditing,
  isSaving = false,
  onEdit,
  onCancel,
  editLabel = 'Edit',
  cancelLabel = 'Cancel',
  saveLabel = 'Save',
  editDisabled = false,
  editDisabledReason = '',
}) => {
  if (!isEditing) {
    const editButton = (
      <button
        type="button"
        onClick={editDisabled ? undefined : onEdit}
        disabled={editDisabled}
        className="px-3 py-1.5 text-xs text-gray-600 bg-white border border-gray-300 rounded-md hover:bg-gray-50 inline-flex items-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white"
      >
        <Edit2 className="h-3 w-3" />
        {editLabel}
      </button>
    );
    if (editDisabled && editDisabledReason) {
      return (
        <Tooltip content={editDisabledReason} side="left">
          <span className="inline-flex">{editButton}</span>
        </Tooltip>
      );
    }
    return editButton;
  }

  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={onCancel}
        className="px-3 py-1.5 text-xs text-gray-600 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
      >
        {cancelLabel}
      </button>
      <button
        type="submit"
        disabled={isSaving}
        className="px-3 py-1.5 text-xs text-white bg-blue-600 rounded-md hover:bg-blue-700 inline-flex items-center gap-1 disabled:opacity-50"
      >
        <Save className="h-3 w-3" />
        {isSaving ? 'Saving...' : saveLabel}
      </button>
    </div>
  );
};

export default InlineEditActions;
